'use client';

import { useCallback, useRef, useState } from 'react';
import { useCurrentApp } from '@/stores/userDataStore';
import { TemplateName } from '@/features/studio-video-templates/types/template';

export enum FormName {
  CreateInfluencer = 'create-influencer',
  AIVideoAssetCreator = 'ai-video-asset-creator',
  AiTryOnCreator = 'ai-try-on-creator',
  CreateBackground = 'create-background',
  CreateImage = 'create-image',
  CreateModel = 'create-model',
  CreateChatToImage = 'create-chat-to-image',
}

const useFormDataState = (name: FormName | TemplateName) => {
  const { owner, appUrl } = useCurrentApp();
  const formDataKey = `${owner}-${appUrl}-${name}`;
  const formDataRef = useRef<Record<string, any>>(
    typeof window !== 'undefined' ? JSON.parse(window.localStorage.getItem(formDataKey) || '{}') : {}
  );

  const [formData, setFormData] = useState<Record<string, any>>(formDataRef.current);

  const handleSetFormData = useCallback(
    (data: Record<string, any>) => {
      window.localStorage.setItem(formDataKey, JSON.stringify(data));
      setFormData(data);
    },
    [formDataKey, setFormData]
  );

  const handleClearFormData = useCallback(
    (keepFormState: boolean = false) => {
      window.localStorage.removeItem(formDataKey);
      if (!keepFormState) {
        setFormData({});
      }
    },
    [formDataKey, setFormData]
  );

  return { formData, handleSetFormData, handleClearFormData };
};

export default useFormDataState;
